exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-clamp-box[data-v-5e280552]{display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2}.line-height-2\\.5[data-v-5e280552]{line-height:2.5}[data-v-5e280552] .el-collapse-item__content{padding-right:10px!important;padding-left:0!important}", ""]);

// exports
